import { initReleaseCountdowns } from '../components/release-countdown.js';

function bootSteamDiscountCountdowns() {
  const page = document.querySelector('.steam-discounts-page');
  if (!page) {
    return;
  }

  initReleaseCountdowns(page);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSteamDiscountCountdowns);
} else {
  bootSteamDiscountCountdowns();
}

document.addEventListener('livewire:navigated', () => {
  requestAnimationFrame(() => {
    setTimeout(bootSteamDiscountCountdowns, 50);
  });
});
